import { useState, useCallback, useEffect } from "react";
import { getArchivedActions, setArchivedActions } from "../utils";

export const useActionArchive = () => {
	const [archivedActionIds, setArchivedActionIds] = useState<Set<string>>(
		getArchivedActions(),
	);

	useEffect(() => {
		setArchivedActions(archivedActionIds);
	}, [archivedActionIds]);

	const archiveAction = useCallback((actionId: string) => {
		setArchivedActionIds((prev) => {
			const next = new Set(prev);
			next.add(actionId);
			return next;
		});
	}, []);

	const unarchiveAction = useCallback((actionId: string) => {
		setArchivedActionIds((prev) => {
			const next = new Set(prev);
			next.delete(actionId);
			return next;
		});
	}, []);

	const isArchived = useCallback(
		(actionId: string) => archivedActionIds.has(actionId),
		[archivedActionIds],
	);

	return {
		archivedActionIds,
		archiveAction,
		unarchiveAction,
		isArchived,
	};
};
